import { __assign, __rest } from "tslib";
import React from 'react';
import InternalContainer from './internal';
import { getExternalProps } from '../internal/utils/external-props';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
export default function Container(_a) {
    var props = __rest(_a, []);
    var baseComponentProps = useBaseComponent('Container');
    var externalProps = getExternalProps(props);
    return React.createElement(InternalContainer, __assign({}, externalProps, baseComponentProps));
}
applyDisplayName(Container, 'Container');
//# sourceMappingURL=index.js.map